import { FrageDisplayModel } from "@/api/models/ace/xFound/Portal/Core/CAQ/Models/frage-display-model";
import { InfotextDisplayModel } from "@/api/models/ace/xFound/Portal/Core/CAQ/Models/infotext-display-model";
import { ValidationFailure } from "@/api/models/FluentValidation/Results/validation-failure";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class StateService {

    protected clearInfoSource = new Subject<void>();
    protected addInfoSource = new Subject<InfotextDisplayModel>();

    clearInfo$ = this.clearInfoSource.asObservable();
    addInfo$ = this.addInfoSource.asObservable();

    protected onValidationErrorsChanged = new Subject<{ [key: string]: ValidationFailure[]; } | null>();
    onValidationErrorsChanged$: Observable<{ [key: string]: ValidationFailure[]; } | null> = this.onValidationErrorsChanged.asObservable();

    setFieldInfoText(info: InfotextDisplayModel) {
        this.addInfoSource.next(info);
    }

    clearFieldInfoText() {
        this.clearInfoSource.next();
    }

    protected _currentFragen: { [name: string]: FrageDisplayModel[] } = {};
    protected _validationErrors: { [key: string]: ValidationFailure[]; } | null;

    protected _isEndvalidationEnabled = false;

    public showProzessNavigation: boolean = true;
    public showAnfrageInfo: boolean = true;

    public get IsEndvalidationEnabled(): boolean {
        return this._isEndvalidationEnabled;
    }

    public set IsEndvalidationEnabled(value: boolean) {
        this._isEndvalidationEnabled = value;
    }

    public get ValidationErrors(): { [key: string]: ValidationFailure[]; } | null {
        return this._validationErrors;
    }

    public set ValidationErrors(value: { [key: string]: ValidationFailure[]; } | null) {
        this._validationErrors = value;
        this.onValidationErrorsChanged.next(this._validationErrors);
    }

    public get CurrentFragen(): { [name: string]: FrageDisplayModel[] } {
        return this._currentFragen;
    }

    public ToggleProzessNavigation() {
        this.showProzessNavigation = !this.showProzessNavigation;
    }

    public ToggleAnfrageInfo() {
        this.showAnfrageInfo = !this.showAnfrageInfo;
    }

    public clearCache() {
        this._currentFragen = {};
        this.ValidationErrors = null;
    }

    public clearQuestions() {
        this._currentFragen = {};
    }
}